import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageNotFound.css';

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="page-not-found">
      <div className="error-container">
        <div className="error-content">
          <div className="error-code">404</div>
          <h1 className="error-title">Lost your way?</h1>
          <p className="error-description">
            Sorry, we can't find that page. You'll find lots to explore on the home page.
          </p>
          
          <div className="error-actions">
            <button className="netflix-button primary" onClick={handleGoHome}>
              Go to Home
            </button>
            <button className="netflix-button secondary" onClick={handleGoBack}>
              Go Back
            </button>
          </div>
        </div>
        
        <div className="error-animation">
          <div className="floating-elements">
            <div className="element element-1">📺</div>
            <div className="element element-2">🎬</div>
            <div className="element element-3">🍿</div>
            <div className="element element-4">🎭</div>
            <div className="element element-5">🎪</div>
            <div className="element element-6">🎨</div>
          </div>
        </div>
      </div>
      
      <div className="suggestions">
        <h2>Popular Pages</h2>
        <div className="suggestion-links">
          <button onClick={() => navigate('/browse')} className="suggestion-link">
            Browse Portfolio
          </button>
          <button onClick={() => navigate('/projects')} className="suggestion-link">
            Projects
          </button>
          <button onClick={() => navigate('/skills')} className="suggestion-link">
            Skills
          </button>
          <button onClick={() => navigate('/contact-me')} className="suggestion-link">
            Contact
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
